import React, {useEffect, useState} from 'react';
import {Select} from 'antd';
import SuperAdminRevenueGraph from '../components/SuperAdminRevenueGraph';
import SuperAdmin_UserStatusGraph from '../components/SuperAdmin_UserStatusGraph';
import api from '../Interceptor';
import {getRoute} from '../api/routes';
const {Option} = Select;

const SuperDashboard = () => {
  const [duration, setDuration] = useState('all');
  const handleDurationChange = (value) => setDuration(value);
  const [activeUsers, setActiveUsers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const inactiveUsers = totalUsers - activeUsers;
  const fetchUsers = async () => {
    try {
      const response = await api.get(
        getRoute('users', 'superadmin', 'admin', false, true, 'list')
      );

      if (response?.data) {
        const users = response.data;

        // Define the active status ID if known (replace with correct value)
        const activeStatusId = process.env.REACT_APP_STATUS_ACTIVE;

        const active = users.filter(
          (user) => user.status === activeStatusId
        ).length;
        const total = users.length;

        setActiveUsers(active);
        setTotalUsers(total);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  return (
    <div className="flex flex-col gap-4 h-full bg-white rounded-xl py-4 px-4 border-2 border-[#E9EAEB]">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
        <div
          style={{fontFamily: 'Noto Serif, sans-serif'}}
          className="mb-4 md:mb-0"
        >
          <h1 className="font-bold text-lg">Dashboard</h1>
        </div>
      </div>

      {/* Stats Section */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {/* Active Users */}
        <div className="border border-[#AFF0CC] bg-[#EDFFF5] shadow-sm rounded-lg py-4 text-center">
          <p className="text-[#006B31] text-sm sm:text-md font-semibold">
            Active Users
          </p>
          <p className="text-[#002410] text-2xl sm:text-3xl font-bold mt-2">
            <i className="fa-solid fa-users mr-2"></i> {activeUsers}
          </p>
        </div>

        {/* Inactive Users */}
        <div className="border border-[#FFE5E3] bg-[#FFF5EF] shadow-sm rounded-lg py-4 text-center">
          <p className="text-[#B51D1D] text-sm sm:text-md font-semibold">
            Inactive Users
          </p>
          <p className="text-[#7C1A1D] text-2xl sm:text-3xl font-bold mt-2">
            <i className="fa-solid fa-users mr-2"></i> {inactiveUsers}
          </p>
        </div>

        {/* Total Users (Centered on Second Row for Tablets) */}
        <div className="border border-[#CCD7FF] bg-[#E5EBFF] shadow-sm rounded-lg py-4 text-center sm:col-span-2 lg:col-span-1 sm:flex sm:justify-center">
          <div>
            <p className="text-[#002199] text-sm sm:text-md font-semibold">
              Total Users
            </p>
            <p className="text-[#000B33] text-2xl sm:text-3xl font-bold mt-2">
              <i className="fa-solid fa-users mr-2"></i> {totalUsers}
            </p>
          </div>
        </div>
      </div>

      {/* Graphs Section */}
      <div className="flex flex-col lg:flex-row gap-4">
        {/* User Statistics */}
        <div className="w-full lg:w-4/12">
          <div className="rounded-lg border border-[#E5E7EB] shadow-sm p-4">
            <SuperAdmin_UserStatusGraph />
          </div>
        </div>
        {/* Revenue Graph */}
        <div className="w-full lg:w-8/12">
          <div className="rounded-lg border border-[#E5E7EB] shadow-sm p-4">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
              <p className="font-semibold font-customFont">Revenue</p>
              <Select
                defaultValue="all"
                required
                value={duration}
                onChange={handleDurationChange}
                onBlur={() => {
                  if (!duration) setDuration('');
                }}
                className="w-full md:w-60"
              >
                <Option value="currentweek">This Week</Option>
                <Option value="last12months">Last 12 Months</Option>
                <Option value="all">All</Option>
              </Select>
            </div>
            <div className="mt-4">
              <SuperAdminRevenueGraph selectedDuration={duration} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuperDashboard;
